import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FcpRadiobuttonComponent, FcpToggleSwitchComponent } from 'fc-design-system';
import { FcpBadgeModule, FcpButtonModule, FcpIconModule, FcpModalModule, FcpTooltipModule } from 'fc-ui-components';
import { DownloadSelectionModalComponent } from './download-selection-modal.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        FcpModalModule,
        FcpBadgeModule,
        FcpButtonModule,
        FcpIconModule,
        FcpTooltipModule,
        FcpRadiobuttonComponent,
        FcpToggleSwitchComponent,
        OverlayModule
    ],
    declarations: [DownloadSelectionModalComponent],
    exports: [DownloadSelectionModalComponent]
})
export class DownloadSelectionModalModule {}
